import { useState, type FormEvent } from "react";

/** The waiting-list signup behind every email form on the site. */
export function useWaitlistSignup() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsLoading(true);
    setError("");
    try {
      const response = await fetch("https://api.octerm.com/waiting-list", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (data.success) setIsSubmitted(true);
      else setError(data.message || "Failed to join waiting list");
    } catch (err) {
      console.error("Error submitting email:", err);
      setError("Failed to join waiting list. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const change = (value: string) => {
    setEmail(value);
    if (error) setError("");
  };

  return { email, change, submit, isSubmitted, isLoading, error };
}
